import { ClaimCandidatesGroupedTable } from "../../components/claims/ClaimCandidatesGroupedTable";
import { PageHeader } from "../../components/layout/PageHeader";

export function RejectedClaimsReportPage({ basePath = "/popup/rejected" }: { basePath?: string } = {}) {
  return (
    <div className="page-stack">
      <PageHeader
        title="Rejected claims"
        description="Claim groups that were reviewed and rejected. Open a claim to see why, or move it back to Potential."
      />
      <ClaimCandidatesGroupedTable
        statusFilter={["rejected"]}
        detailPath={(id) => `${basePath}/${id}`}
        showActions
        actionPreset="review"
        emptyMessage="No rejected claims."
      />
    </div>
  );
}
